import clsx from 'clsx';
import React, { useState } from 'react';
import InternalFormField from '../../form-field/internal';
import InternalInput from '../../input/internal';
import InternalRadioGroup from '../../radio-group/internal';
import InternalSelect from '../../select/internal';
import InternalSpaceBetween from '../../space-between/internal';
import styles from './styles.css.js';
var units = [
    'second',
    'minute',
    'hour',
    'day',
    'week',
    'month',
    'year'
];
var CUSTOM_OPTION_SELECTKEY = 'awsui-internal-custom-duration-key';
var DEFAULT_CUSTOM_UNITOFTIME = 'minute';
export var RelativeRangePicker = function (_a) {
    var _b;
    var _c;
    var _d = _a.options, options = _d === void 0 ? [] : _d, initialRange = _a.initialSelection, onChangeRangeSize = _a.onChange, isSingleGrid = _a.isSingleGrid, i18nStrings = _a.i18nStrings;
    var mappedOptions = options.map(function (option) { return ({
        value: option.key,
        label: i18nStrings.formatRelativeRange(option)
    }); });
    var radioOptions = mappedOptions.concat([
        {
            value: CUSTOM_OPTION_SELECTKEY,
            label: i18nStrings.customRelativeRangeOptionLabel,
            description: i18nStrings.customRelativeRangeOptionDescription
        }
    ]);
    var _e = useState(function () {
        var _a;
        if (initialRange && !initialRange.key) {
            return CUSTOM_OPTION_SELECTKEY;
        }
        return (_a = initialRange === null || initialRange === void 0 ? void 0 : initialRange.key) !== null && _a !== void 0 ? _a : null;
    }), selectedRadio = _e[0], setSelectedRadio = _e[1];
    var _f = useState(function () {
        if (initialRange && !initialRange.key) {
            return initialRange.amount;
        }
        // NaN represents an empty duration
        return NaN;
    }), customDuration = _f[0], setCustomDuration = _f[1];
    var _g = useState((_c = initialRange === null || initialRange === void 0 ? void 0 : initialRange.unit) !== null && _c !== void 0 ? _c : DEFAULT_CUSTOM_UNITOFTIME), customUnitOfTime = _g[0], setCustomUnitOfTime = _g[1];
    return (React.createElement(InternalSpaceBetween, { size: "xs", direction: "vertical" },
        React.createElement(InternalFormField, { label: i18nStrings.relativeRangeSelectionHeading },
            React.createElement(InternalRadioGroup, { className: styles['relative-range-radio-group'], onChange: function (_a) {
                    var detail = _a.detail;
                    setSelectedRadio(detail.value);
                    if (detail.value === CUSTOM_OPTION_SELECTKEY) {
                        setCustomDuration(NaN);
                        setCustomUnitOfTime(DEFAULT_CUSTOM_UNITOFTIME);
                        onChangeRangeSize({
                            amount: NaN,
                            unit: DEFAULT_CUSTOM_UNITOFTIME,
                            type: 'relative'
                        });
                    }
                    else {
                        var option = options.filter(function (o) { return o.key === detail.value; })[0];
                        onChangeRangeSize(option);
                    }
                }, value: selectedRadio, items: radioOptions })),
        selectedRadio === CUSTOM_OPTION_SELECTKEY && (React.createElement("div", { className: styles['custom-range'] },
            React.createElement("div", { className: clsx(styles['custom-range-form-controls'], (_b = {},
                    _b[styles.vertical] = isSingleGrid,
                    _b)) },
                React.createElement("div", { className: styles['custom-range-duration'] },
                    React.createElement(InternalFormField, { label: i18nStrings.customRelativeRangeDurationLabel },
                        React.createElement(InternalInput, { type: "number", className: styles['custom-range-duration-input'], value: isNaN(customDuration) || customDuration === 0 ? '' : customDuration === null || customDuration === void 0 ? void 0 : customDuration.toString(), onChange: function (e) {
                                var amount = Number(e.detail.value);
                                setCustomDuration(amount);
                                onChangeRangeSize({ amount: amount, unit: customUnitOfTime, type: 'relative' });
                            }, placeholder: i18nStrings.customRelativeRangeDurationPlaceholder }))),
                React.createElement("div", { className: styles['custom-range-unit'] },
                    React.createElement(InternalFormField, { label: i18nStrings.customRelativeRangeUnitLabel },
                        React.createElement(InternalSelect, { className: styles['custom-range-unit-select'], selectedOption: {
                                value: customUnitOfTime,
                                label: i18nStrings.formatUnit(customUnitOfTime, customDuration)
                            }, onChange: function (e) {
                                var unit = e.detail.selectedOption.value;
                                setCustomUnitOfTime(unit);
                                onChangeRangeSize({ amount: customDuration, unit: unit, type: 'relative' });
                            }, options: units.map(function (unit) { return ({
                                value: unit,
                                label: i18nStrings.formatUnit(unit, customDuration)
                            }); }) }))))))));
};
//# sourceMappingURL=index.js.map